import React from 'react'

import { ArrowRightIcon } from '@hm-group/fabric-icons'
import { BodyText, HeadingMedium, Image, HeadingSmall } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'
import cn from 'classnames'
import { Link } from 'react-router-dom'
import OPTIMIZELY from 'constants/optimizely'
import useOptimizelyDecision, {
  useNorthstarABTestEnabled,
} from 'features/account/hooks/useOptimizelyDecision'
import { trackOptimizelyEvent } from 'helpers/optimizely'

import MemberCards from '../../types'
import getRoute from '../helpers/getRoute'
import RenderSubtext from '../RenderSubtext/RenderSubtext'
import styles from './Cards.scss'

const Cards: React.FC<MemberCards> = ({
  headline,
  subText1,
  subText2,
  subText3,
  subText2Cta,
  subText3Cta,
  iconPath,
}) => {
  const isNorthstarBrand = useOptimizelyDecision(OPTIMIZELY.ACCOUNT_NORTHSTAR_VARIATION)
  const isNorthStarABtestEnabled = useNorthstarABTestEnabled(OPTIMIZELY.ACCOUNT_NORTHSTAR_VARIATION)
  const trackViewAll = (): void => {
    if (
      (isNorthStarABtestEnabled && subText2Cta === 'viewAllRewards') ||
      subText3Cta === 'viewAllRewards'
    ) {
      trackOptimizelyEvent(OPTIMIZELY.ACCOUNT_VIEW_REWARD_MEMBERSHIP)
    }
  }
  return (
    <div className={cn(styles.cards, isNorthstarBrand && styles.cardBlock)}>
      {!isNorthstarBrand && (
        <Image
          className={styles.iconWrapper}
          url={iconPath}
          altText={getLabelFromStorage('myaccount.member.cards.icon.accessibility', {
            replacements: [headline],
          })}
        />
      )}
      <div className={styles.cardDescription}>
        {isNorthstarBrand ? (
          <HeadingSmall Tag="h3" className={styles.smallHeadline} ellipsis>
            {headline}
          </HeadingSmall>
        ) : (
          <HeadingMedium Tag="h2" className={styles.headline} ellipsis>
            {headline}
          </HeadingMedium>
        )}
        <BodyText className={styles.subText1} lineClamp={2} ellipsis>
          {subText1}
        </BodyText>
        {subText2 && RenderSubtext(subText2, subText2Cta, trackViewAll)}
        {subText3 && RenderSubtext(subText3, subText3Cta, trackViewAll)}
      </div>
      {isNorthstarBrand && (
        <Link className={styles.arrowIcon} to={getRoute(subText2Cta || subText3Cta)}>
          <ArrowRightIcon />
        </Link>
      )}
    </div>
  )
}
export default Cards
